import React, { useState, useEffect, useContext } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import { AuthContext } from "../../context/auth-context";

import {
  BaseButtons,
  IconOnlyButton,
  LoadingPopUp,
  ToastNotification,
} from "../common-components";
import { useNavigate } from "react-router-dom";

import {
  BecomeAgent,
  CardDisplay,
  ForgotPasswordPopUp,
  LandingCard,
  ProfilePopUp,
  RegistrationPopUp,
} from "./components";

const Website = () => {
  const navigate = useNavigate();
  const { width, height } = useWindowDimensions();
  const [displayedIndex, setDisplayedIndex] = useState(0);
  const [reset, setRest] = useState(false);
  const [profile, setProfile] = useState(false);
  const [registerPop, setRegisterPop] = useState(false);
  const [forgotPasswordPop, setForgotPasswordPop] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);
  const [toastPop, setToastPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [message, setMessage] = useState("");
  const [refresh, setFresh] = useState(false);

  const auth = useContext(AuthContext);

  const [firstName, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [cellNumber, setCellNumber] = useState("");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [tandC, setTandC] = useState("");

  const [loginPassword, setLoginPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [selectedCardInfo, setSelectedCardInfo] = useState(null);
  const [webCards, setWebCards] = useState(null);

  const [agentPopUp, setAgentPopUp] = useState(false);

  const [shareAccount, setShareAccount] = useState(null);
  const handleDownload = () => {
    const apkUrl = "driversfriend.apk"; // path in your public folder or a full URL

    const link = document.createElement("a");
    link.href = apkUrl;
    link.download = "DriversFriend.apk"; // filename for the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const backGroundColorSelecto = () => {
    if (displayedIndex === 0) {
      return colors.greenDark;
    } else if (displayedIndex === 1) {
      return colors.greenLight;
    } else if (displayedIndex === 2) {
      return colors.greenDark;
    } else if (displayedIndex === 3) {
      return colors.greenLight;
    } else if (displayedIndex === 4) {
      return colors.greenDark;
    } else if (displayedIndex === 5) {
      return colors.greenLight;
    }
  };

  const GetShareAccount = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getUserShareAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,
            email: auth.customerUserData.email,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.shareAccount) {
        setLoading(false);
        setToastPop(true);
        setMessage("Created Share Account");
        setPopUpTitle("SUCCESS");
        setShareAccount(respnseData.shareAccount);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage("Could not create yur share account please contact support");
        setLoading(false);
      }
    } catch (err) {}
  };

  const LoginHandler = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/user/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: userName,
            password: loginPassword,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.userId) {
        auth.login();
        auth.customerLoadData({
          acceptedTandC: respnseData.acceptedTandC,
          cellNumber: respnseData.cellNumber,
          dateOfBirth: respnseData.dateOfBirth,
          email: respnseData.email,
          firstName: respnseData.firstName,
          gender: respnseData.gender,
          idDoc: respnseData.idDoc,
          lastName: respnseData.lastName,
          message: respnseData.message,
          street: respnseData.street,
          suburb: respnseData.suburb,
          town: respnseData.town,
          userId: respnseData.userId,
          rewardPoints: respnseData.rewardPoints,
          profileProgress: respnseData.profileProgress,
          status: respnseData.status,
          type: respnseData.type,
        });
        await GetShareAccount();
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("Log-in successful");
        setLoading(false);
        setRegisterPop(false);
        setProfile(true);
        if (respnseData.type === "Customer") {
          navigate("/driversFriendMobile");
        } else {
          navigate("/admin");
        }

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to Login because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const registerationHandler = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/user/reg",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            firstName: firstName.replace(/\\|\//g, ""),
            lastName: lastname.replace(/\\|\//g, ""),
            cellNumber: cellNumber.replace(/\\|\//g, ""),
            email: email.toLowerCase().replace(/\\|\//g, ""),
            password: password,
            acceptedTandC: tandC,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.userId) {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(
          "Your registration was successful, you can now login and get started...."
        );
        setLoading(false);
        setRegisterPop(false);
        setProfile(true);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to register because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to resgister account, some of the information provided is already in our system" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const SelectCard = (value) => {
    setHasClicked(false);
    setDisplayedIndex(value);
  };

  const ScreenDisplayed = (value) => {
    if (value === 0) {
      setDisplayedIndex(1);
    } else if (value === 1) {
      setDisplayedIndex(2);
    } else if (value === 2) {
      setDisplayedIndex(3);
    } else if (value === 3) {
      setDisplayedIndex(4);
    } else if (value === 4) {
      setDisplayedIndex(0);
    } else if (value === 5) {
      setDisplayedIndex(0);
    }
  };

  const GetCards = async () => {
    await fetch(process.env.REACT_APP_BACKEND_URL + "/website/getCards")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setWebCards(resData);
      });
  };

  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);

        setTimeout(() => {
          setPopUpTitle("");
          setMessage("");
        }, 3000);
      }, 5000);
    }
  }, [toastPop]);
  useEffect(() => {
    GetCards();
  }, [refresh]);

  return (
    <div
      style={{
        height: height,
        width: width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: backGroundColorSelecto(),
        position: "relative",
        transition: "all 1s",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 20,
          top: 15,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          height={40}
          width={150}
          label={"ANDROID APK"}
          onClick={() => handleDownload()}
          backgroundColor={colors.greenLight}
          borderRadius={8}
        />

        {width >= 899 ? <div style={{ minWidth: 20 }} /> : null}
        {width >= 899 ? (
          <BaseButtons
            height={40}
            width={150}
            label={"BUSINESS LOGIN"}
            onClick={() => navigate("/agency")}
            backgroundColor={colors.greenLight}
            borderRadius={8}
          />
        ) : null}

        {width >= 899 ? <div style={{ minWidth: 20 }} /> : null}
        {width >= 899 ? (
          <BaseButtons
            height={40}
            width={180}
            label={"REGISTER BUSINESS"}
            onClick={() => setAgentPopUp(true)}
            backgroundColor={colors.greenLight}
            borderRadius={8}
          />
        ) : null}
        {width >= 899 ? <div style={{ minWidth: 20 }} /> : null}
        <IconOnlyButton
          height={50}
          width={50}
          iconImage={require("../../images/icons/profileWhite.png")}
          onClick={() => setRegisterPop(true)}
        />
      </div>
      <div
        style={{
          position: "absolute",
          left: width > 899 ? 10 : 0,
          top: width > 899 ? 0 : 0,
        }}
      >
        <img
          alt="logo"
          src={require("../../images/base-logo-desgns/driverfrinedlogo4.png")}
          style={{ height: width > 899 ? 100 : 80 }}
        />
      </div>
      {webCards ? (
        webCards.cards.map((card, index) => {
          return (
            <div
              key={index}
              style={{
                height: displayedIndex === index ? "100%" : 0,
                width: displayedIndex === index ? "100%" : 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "all 0.5s",
              }}
            >
              <LandingCard
                index={index}
                onRegClick={() => setRegisterPop(true)}
                backgroundColorButton={backGroundColorSelecto()}
                width={width}
                display={displayedIndex === index ? true : false}
                info={card ? card.paragraph1 : null}
                info2={card ? card.paragraph2 : null}
                cardImage={card ? card.imageLink : null}
                imageHeight={width > 599 ? 250 : 120}
                cardtitle={card ? card.cardTitle : null}
                shortText={card ? card.tagLine : null}
                onNextClick={() => ScreenDisplayed(index)}
                subTitle={card ? card.subTitle : null}
              />
            </div>
          );
        })
      ) : (
        <LoadingPopUp display={true} />
      )}

      <ForgotPasswordPopUp
        display={forgotPasswordPop}
        onCloseClick={() => {
          setForgotPasswordPop(false);
          setProfile(true);
        }}
        width={width}
      />
      <RegistrationPopUp
        display={registerPop}
        email={email}
        firstName={firstName}
        lastName={lastname}
        cellNumber={cellNumber}
        tandc={tandC}
        onEmailChange={(e) => setEmail(e.target.value)}
        onCellChange={(e) => setCellNumber(e.target.value)}
        password={password}
        confirmPassword={confirmPassword}
        onRegClick={() => registerationHandler()}
        onPasswordChange={(e) => setPassword(e.target.value)}
        onConfirmPasswordChange={(e) => setConfirmPassword(e.target.value)}
        onFirstNameChange={(e) => setFirstName(e.target.value)}
        onLastNameChange={(e) => setLastName(e.target.value)}
        onTermsClick={() => setTandC(tandC ? false : true)}
        onCloseClick={() => {
          setRegisterPop(false);
          // setProfile(true);
        }}
        onLoginClick={() => LoginHandler()}
        emailLogin={userName}
        onEmailLoginChange={(e) => setUserName(e.target.value)}
        passwordLogin={loginPassword}
        onPasswordLoginChange={(e) => setLoginPassword(e.target.value)}
        width={width}
      />
      <BecomeAgent
        display={agentPopUp}
        setAgentPopUp={setAgentPopUp}
        setLoading={setLoading}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
      />

      <LoadingPopUp display={loading} />
      <ToastNotification
        display={toastPop}
        title={popUpTitle}
        mainTitle={popUpTitle}
        message={message}
        width={width}
      />
    </div>
  );
};

export default Website;
